module.exports = __webpack_public_path__ + "static/media/add-link-icon.d6a58b6d.svg";